import { MegaraxClient } from "@megarax/client/src";

export default new MegaraxClient({
  baseUrl: process.env.VUE_APP_REST_API_ULR!,
});
